import { getOptimisedS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";

export const locked_svg = getOptimisedS3AssetCDNUrl("Account/locked.png");
